var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightWhiteCompact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9L9 16.5l-1.072-1.072 5.677-5.678H1.5v-1.5h12.105L7.928 2.572 9 1.5 16.5 9z",
    fill: "#FFF"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjUgOC45OTk1OEw5LjAwMDQxIDE2LjVMNy45Mjc5NCAxNS40Mjc1TDEzLjYwNTUgOS43NUwxLjUgOS43NUwxLjUgOC4yNUwxMy42MDU0IDguMjVMNy45Mjc5MiAyLjU3MjQ3TDkuMDAwMzkgMS41TDE2LjUgOC45OTk1OFoiIGZpbGw9IiNGRkZGRkYiLz4KPC9zdmc+Cg==";
export { SvgArrowRightWhiteCompact as ReactComponent };